import type { FC } from "react"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import { type SalesOrder, SalesOrderStatus } from "@/graphql/codegen/graphql"
import { NotificationType } from "@/schemas/notification"
import { useUpdateSalesOrder } from "@/screens/CustomerOrders/hooks/useUpdateSalesOrder"

interface SalesOrderCancelConfirmationDialogProps {
  salesOrder: SalesOrder
  onClose: () => void
  onSubmit: () => void
}

export const SalesOrderCancelConfirmationDialog: FC<SalesOrderCancelConfirmationDialogProps> = ({
  salesOrder,
  onClose,
  onSubmit,
}) => {
  const { updateSalesOrder, isSaving } = useUpdateSalesOrder()

  const handleConfirm = async () => {
    const canceledSalesOrder = await updateSalesOrder(
      { salesOrderId: salesOrder.salesOrderId, status: SalesOrderStatus.Canceled },
      { successMessage: `Sales Order ${salesOrder.publicId} cancelled`, successType: NotificationType.Error }
    )
    if (canceledSalesOrder) onSubmit()
  }

  const handleClose = () => {
    if (isSaving) return
    onClose()
  }

  return (
    <ConfirmationDialog
      title={`Cancel sales order ${salesOrder.publicId}?`}
      content='This sales order will be canceled and cannot be reopened. This action cannot be undone.'
      closeLabel='Back'
      confirmLabel='Cancel Sales Order'
      confirmDisabled={isSaving}
      testIdPrefix='customer-orders.cancel-confirmation-dialog'
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  )
}
